import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

// Actions
import UploadAction from "@common/redux/actions/UploadAction";
import LoginAction from "@common/redux/actions/LoginAction";

// Client
import MediaClient from "@common/api/MediaClient";

// Helpers
import { handleError } from "@common/components/helpers/error";
import { handleSuccess } from "@common/components/helpers/success";
import fetchCctvImages from "@common/components/helpers/fetchCctvImages";

const useUpload = () => {
  const { incidentId, progress } = useSelector((state) =>
    UploadAction.getStatePath(state),
  );

  const fileInputRef = useRef(null);
  const [imageToUpload, setImageToUpload] = useState(null);

  useEffect(() => {
    fetchCctvImages(incidentId);
  }, [incidentId]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageToUpload(file);
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleUpload = () => {
    if (imageToUpload) {
      const reader = new FileReader();
      reader.readAsDataURL(imageToUpload);

      reader.onload = () => {
        const fileData = reader.result.split(",")[1];
        MediaClient.Create(
          {
            incidentId: incidentId,
            fileName: imageToUpload.name,
            data: fileData,
          },
          {
            onUploadProgress: function (progressEvent) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              UploadAction.dispatch({ progress: percentCompleted });
            },
          },
        )
          .then(
            () =>
              handleSuccess(
                "The CCTV file was successfully submitted!",
                null,
                "/compliance",
              ),
            (error) =>
              handleError(
                error,
                "Error",
                "There is an error submitting the CCTV file.",
              ),
          )
          .finally(() => {
            UploadAction.dispatch({ progress: 0 });
            setImageToUpload(null);
            fileInputRef.current.value = null;
            fetchCctvImages(incidentId);
            LoginAction.dispatch({ isInReadMode: true });
          });
      };
    }
  };

  return {
    fileInputRef,
    imageToUpload,
    setImageToUpload,
    progress,
    handleFileChange,
    handleButtonClick,
    handleUpload,
  };
};

export default useUpload;
